import { type DateTime } from "luxon";

export default class LockWindow {
  constructor(
    public IsLocked: boolean,
    public Start: DateTime,
    public End: DateTime
  ) {}
}
